import { connect } from "react-redux";
import {
  cancelEditAccountSettings,
  patchEditAccountSettings,
  saveAccountSettingsBeingEdited
} from "./actions/accountSettings";

import EditAccountSettingsDialog from "./EditAccountSettingsDialog";

const mapStateToProps = (state, ownProps) => {
  const { id, accountId } = state.modalForm.editAccountSettings;
  const accountEntity = state.entities.accounts[accountId];
  const isInvalidAccount = typeof accountEntity === "undefined" && id !== "NEW";
  if (!id || isInvalidAccount) {
    return {
      open: false,
      accountSettings: {
        useLimits: false
      }
    };
  }

  const accountSettings = {
    useLimits: Object.keys(state.entities.accountSettings).length > 0,
    ...state.entities.accountSettings,
    ...state.modalForm.editAccountSettings
  };
  return {
    accountSettings,
    open: true
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSave: () => {
      dispatch(saveAccountSettingsBeingEdited());
    },
    onChange: patch => {
      dispatch(patchEditAccountSettings(patch));
    },
    onCancel: () => {
      dispatch(cancelEditAccountSettings());
    }
  };
};

const EditAccountSettingsDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAccountSettingsDialog);

export default EditAccountSettingsDialogContainer;



// WEBPACK FOOTER //
// ./src/EditAccountSettingsDialogContainer.js